import { useEffect } from 'react';
import Spacing from 'components/Spacing';
import { Footer } from 'components/Footer';
import { Header } from 'components/Header';
import { Body } from 'components/Typography';
import { useAppDispatch, useAppSelector } from 'helpers/hooks';
import { getBio } from 'store/bio/actions';
import {
  Container,
  Block,
  FullImage,
  GraySection,
  StyledImage,
  TextsContainer,
  Description,
  PageTitleWrapper,
  SectionTitle,
  PageTitleAccent,
} from './styled';
import { getBioState } from 'selectors/bio';
import { ENV_CONFIG } from 'config/environment';
import Loader from 'components/Loader';

export const BioScreen = () => {
  const dispatch = useAppDispatch();
  const bioState = useAppSelector(state => getBioState(state));

  useEffect(() => {
    dispatch(getBio());
  }, []);

  if (bioState.isLoading || !bioState.data) return <Loader type="dots" />;

  return (
    <>
      <Header />
      <Container>
        <PageTitleWrapper>
          <SectionTitle dangerouslySetInnerHTML={{ __html: bioState.data[0].title }} />
          <PageTitleAccent />
        </PageTitleWrapper>
        <Block>
          <StyledImage $float="left" src={ENV_CONFIG().CLOUDINARY.BIO_1} />
          <TextsContainer>
            <Description dangerouslySetInnerHTML={{ __html: bioState.data[0].desc }} />
          </TextsContainer>
        </Block>
      </Container>
      <GraySection>
        <PageTitleWrapper>
          <SectionTitle dangerouslySetInnerHTML={{ __html: bioState.data[0].title2 }} />
          <PageTitleAccent />
        </PageTitleWrapper>
        <Spacing $size={8} />
        <Body dangerouslySetInnerHTML={{ __html: bioState.data[0].desc2 }} />
      </GraySection>
      <Container>
        <PageTitleWrapper>
          <SectionTitle dangerouslySetInnerHTML={{ __html: bioState.data[0].title3 }} />
          <PageTitleAccent />
        </PageTitleWrapper>
        <FullImage src={ENV_CONFIG().CLOUDINARY.TALLER} />
      </Container>
      <Footer />
    </>
  );
};
